import { createClient } from '@supabase/supabase-js';
import Cookies from 'js-cookie';

const SUPABASE_URL      = process.env.SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.SUPABASE_ANON_KEY || '';

function base64UrlDecode(input) {
  // console.log(`[Supabase-Debug] base64UrlDecode: Attempting to decode: "${input.substring(0, 30)}..."`);
  try {
    let base64 = input.replace(/-/g, '+').replace(/_/g, '/');

    const padding = input.length % 4;
    if (padding === 2) {
      base64 += '==';
    } else if (padding === 3) {
      base64 += '=';
    }

    const decoded = atob(base64);
    // console.log(`[Supabase-Debug] base64UrlDecode: Successfully decoded.`);
    return decoded;
  } catch (e) {
    // console.error(`[Supabase-Debug] base64UrlDecode: FAILED. Error: "${e.message}". Input was: "${input}"`);
    throw e; 
  }
}

const cookieAdapter = {
  getItem: (key) => {
    // console.log(`[Supabase-Debug] getItem: Supabase is asking for key: "${key}"`);
    const allCookies = Cookies.get();

    if (allCookies[key + '.0'] === undefined) {
      const singleCookie = allCookies[key];
      if (!singleCookie) {
        // console.log(`[Supabase-Debug] getItem: No single cookie found for key "${key}". Returning null.`);
        return null;
      }

      // console.log(`[Supabase-Debug] getItem: Found single (non-chunked) cookie.`);
      if (singleCookie.startsWith('base64-')) {
        const rawBase64 = singleCookie.substring(7);
        try {
          return base64UrlDecode(rawBase64);
        } catch (e) {
          // console.error(`[Supabase-Debug] getItem: FAILED to decode single cookie.`, e.message);
          return null;
        }
      }
      return singleCookie; 
    }

    // console.log(`[Supabase-Debug] getItem: Chunking detected. Reading chunks for key: "${key}"`);
    const cookieChunks = [];
    
    for (const cookieKey in allCookies) {
      if (cookieKey.startsWith(key + '.')) {
        // console.log(`[Supabase-Debug] getItem: Found matching chunk: "${cookieKey}"`);
        cookieChunks.push({ key: cookieKey, value: allCookies[cookieKey] });
      }
    }

    if (cookieChunks.length === 0) {
      // console.log(`[Supabase-Debug] getItem: Chunking detected but no chunks found? Returning null.`);
      return null;
    }

    cookieChunks.sort((a, b) => {
      const aIndex = parseInt(a.key.split('.').pop() || '0', 10);
      const bIndex = parseInt(b.key.split('.').pop() || '0', 10);
      return aIndex - bIndex;
    });

    const rawValue = cookieChunks.map(chunk => chunk.value).join('');
    // console.log(`[Supabase-Debug] getItem: Joined raw value (snippet): "${rawValue.substring(0, 30)}..."`);

    if (rawValue.startsWith('base64-')) {
      const rawBase64 = rawValue.substring(7); // Remove "base64-"
      // console.log(`[Supabase-Debug] getItem: Removed 'base64-' prefix. Passing to decoder...`);
      
      try {
        const decodedJson = base64UrlDecode(rawBase64);
        // console.log(`[Supabase-Debug] getItem: Successfully decoded JSON. Returning to Supabase.`);
        return decodedJson;
      } catch (e) {
        // console.error(`[Supabase-Debug] getItem: FAILED to decode Base64. Returning null.`, e.message);
        return null;
      }
    }
    
    return rawValue;
  },
  
  setItem: (key, value) => {
    // console.log(`[Supabase-Debug] setItem: Key: "${key}", Value (snippet): "${String(value).substring(0, 30)}..."`);
    Cookies.set(key, value, { sameSite: 'strict', path: '/' });
  },
  removeItem: (key) => {
    // console.log(`[Supabase-Debug] removeItem: Key: "${key}"`);
    const allCookies = Cookies.get();
    for (const cookieKey in allCookies) {
      if (cookieKey.startsWith(key)) {
        // console.log(`[Supabase-Debug] removeItem: Removing chunk: "${cookieKey}"`);
        Cookies.remove(cookieKey, { path: '/' });
      }
    }
  },
};
export const supabase = (SUPABASE_URL && SUPABASE_ANON_KEY)
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        storage: cookieAdapter,
        persistSession: true,
        autoRefreshToken: true,
      }
    })
  : null;

if (typeof window !== 'undefined') {
  // console.log(`[Supabase-Debug] createClient called. URL: ${SUPABASE_URL}, Key Provided: ${!!SUPABASE_ANON_KEY}`);
  window.__SB_BUILD__ = { url: SUPABASE_URL, hasKey: !!SUPABASE_ANON_KEY };
  window.__supabase = supabase;
}